import React from "react";
import { withSafeRotateSvg } from "../../hoc/withSafeRotateSvg";

const CurvedBorderVertical: React.FC<DogsTrust.CurveProps> = ({
	fill = "#FFC800",
	className,
	style,
}) => {
	return (
		<svg
			className={className}
			style={style}
			aria-hidden="true"
			focusable="false"
			viewBox="0 0 300 1920"
			xmlns="http://www.w3.org/2000/svg"
			preserveAspectRatio="xMidYMid slice"
		>
			<path
				d="M300 0v1920H0V0h300Zm-56.686 1732.626C63.81 1311.1-7.016 1108.241 200.96 161.316 212.705 107.816 221.803 53.9 228.543 0H300v1920c-6.74-50.12-24.88-112.734-56.686-187.374Z"
				fill={fill}
				fillRule="evenodd"
			/>
		</svg>
	);
};

export default withSafeRotateSvg<DogsTrust.CurveProps>(CurvedBorderVertical);
